import { DefaultRouter } from "./default-router";

// pro
import { SimpleRouter } from "./simple-router";

export const IndexRouters = [...DefaultRouter, ...SimpleRouter];
